export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBoldItalic.e9825552.ttf";